module.exports = __webpack_public_path__ + "static/contact-background-af8208e0b003038beabccdaeb43e7429.jpg";